// extracted by mini-css-extract-plugin
export default {"content":"Error_content__Wq6Qe","links":"Error_links__W+fLO","button":"Error_button__3gAZV"};